export enum FecAccountMappingFilter {
  All = 'all',
  New = 'new',
}
